import { Component, OnInit } from '@angular/core';
import { AutenticacionService } from '../generico/servicio/autenticacion.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    private auth : AutenticacionService
  ) { }

  ngOnInit(): void {

    this.auth.logout()


  }

}
